// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__34nfe","paramInput":"JobSimulator_paramInput__JeUH1","input":"JobSimulator_input__TZz6S"};